module.exports = __webpack_public_path__ + "static/img/16.12d063d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/16.jpg
// module id = Znek
// module chunks = 18